/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-misc-bill-item.reducer';

export const PharmacyMiscBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyMiscBillItemEntity = useAppSelector(state => state.pharmacyMiscBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyMiscBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.detail.title">PharmacyMiscBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="qty">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.qty">Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.qty}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.lastupdated}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.paidAmount}</dd>
          <dt>
            <span id="gst">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.gst">Gst</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.gst}</dd>
          <dt>
            <span id="chargeName">
              <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.chargeName">Charge Name</Translate>
            </span>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.chargeName}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.pharmacyBill">Pharmacy Bill</Translate>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.pharmacyBill ? pharmacyMiscBillItemEntity.pharmacyBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{pharmacyMiscBillItemEntity.scheme ? pharmacyMiscBillItemEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-misc-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-misc-bill-item/${pharmacyMiscBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyMiscBillItemDetail;
